import {
  ToggleBlockType
} from './block-type'

export class OrderedList extends ToggleBlockType {
  getBlockType = () => 'ordered-list-item'

  getButtonText = () => 'OL'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/ordered-list.js
 **/